import { SET_REPORTS, LOADING_REPORTS, DOWNLOADING_REPORTS } from "@/store/actions/reportsActions";

const initialState = {
    loading: true,
    data: [],
    total: 0,
    totalStudents: 0,
    downloading: false,
};

const reportsReducer = (state = initialState, action) => {
    if (action.type === SET_REPORTS) {
        return {
            ...state,
            data: action.payload.data,
            total: action.payload.total,
            totalStudents: action.payload.totalStudents,
            loading: false,
        };
    } else if (action.type === LOADING_REPORTS) {
        return { ...state, loading: action.payload };
    } else if (action.type === DOWNLOADING_REPORTS) {
        return { ...state, downloading: action.payload };
    } else {
        return state;
    }
};

export default reportsReducer;
